module.exports = __webpack_public_path__ + "media/images/sp/img_gotop-bc75aefd0948d3569a78772653af58ff.png";